import React from "react";
import { Quote, MessageCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

// Real customer quotes go here as they come in: { quote, name, role, location }
const TESTIMONIALS = [];

export default function TestimonialsSection() {
  return (
    <section data-testid="testimonials-section" className="py-20 md:py-28" style={{ background: "var(--surface)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="eyebrow">Customer stories</div>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <h2 className="display mt-4 max-w-3xl" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "var(--ink)" }}>
            Real reviews, <span className="sunset-text">as they come in</span>.
          </h2>
          <Link to="/reviews" data-testid="testimonials-see-all" className="inline-flex items-center gap-2 text-sm font-medium sunset-text py-2">
            See all reviews <ArrowRight size={14} color="var(--sun-orange)" />
          </Link>
        </div>

        {TESTIMONIALS.length > 0 ? (
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t) => (
              <figure key={t.name} className="p-8 glossy rounded-2xl">
                <Quote size={22} color="var(--sun-orange)" strokeWidth={1.5} />
                <blockquote className="mt-5 text-base leading-relaxed" style={{ color: "var(--ink)" }}>
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 text-sm">
                  <div className="font-medium" style={{ color: "var(--ink)" }}>{t.name}</div>
                  <div style={{ color: "var(--ink-soft)" }}>{t.role} · {t.location}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        ) : (
          <div className="mt-12 p-8 sm:p-10 glossy rounded-2xl md:flex items-center justify-between gap-8">
            <div className="max-w-xl">
              <Quote size={24} color="var(--sun-orange)" strokeWidth={1.5} />
              <p className="mt-4 text-base sm:text-lg leading-relaxed" style={{ color: "var(--ink)" }}>
                The CORE 500 has just launched — and we only publish <strong>real, verified
                customer reviews</strong>. Yours could be the first one here.
              </p>
              <p className="mt-2 text-sm" style={{ color: "var(--ink-soft)" }}>
                Bought one? Tell us how it pressed — Ankara, denim, the morning shirt rush.
              </p>
            </div>
            <a
              data-testid="testimonial-share-cta"
              href="https://wa.me/2347072260372?text=I'd%20like%20to%20share%20my%20CORE%20500%20experience"
              className="btn-brand justify-center mt-6 md:mt-0 flex-shrink-0"
            >
              <MessageCircle size={16} /> Share your experience
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
